import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "../lib/theme";
import { useI18n } from "../lib/i18n";

const ORDER = ["light", "dark", "system"];
const ICONS = { light: Sun, dark: Moon, system: Monitor };

export function ThemeToggle() {
  const { pref, theme, setPref } = useTheme();
  const { t } = useI18n();
  const mode = ORDER.includes(pref) ? pref : theme;
  const Icon = ICONS[mode] || Sun;
  const next = ORDER[(ORDER.indexOf(mode) + 1) % ORDER.length];
  return (
    <button
      className="p-2 rounded-xl text-rail-ink/70 hover:text-brand hover:bg-rail-soft transition-colors"
      onClick={() => setPref(next)}
      title={t(`theme.${mode}`)}
      aria-label={t(`theme.${mode}`)}
      data-testid="theme-toggle"
    >
      <Icon size={18} />
    </button>
  );
}
